export default __webpack_public_path__ + "static/media/main_bg_left_one.8c92d6d7.svg";